function TitleArea(props: any) {
  let myProps = {
    Style: null,
    todo_info: null,
    ...props
  };
  let Style = myProps.Style;
  let todo_info = myProps.todo_info;

  return (
    <div className={Style.popup_titile_wrap}>
      {todo_info &&
        <div className={Style.title_container}>
          <div className={Style.title_content}>
            <div className={Style.title_main}>
              {todo_info.a_title}
              <span className={Style.title_stu_name_wrap}>
                <span>이름:</span>
                <span className={Style.title_stu_name} >{todo_info.a_stu_name}</span>
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  );
};
export default TitleArea;